module.exports = __webpack_public_path__ + "img/LUB00368.15cf2e74.png";